import { createApi } from '@reduxjs/toolkit/query/react'
import {baseQuery} from "../baseQuery";

const refetchSeconds = process.env.REACT_APP_REFETCH_SECONDS ? parseInt(process.env.REACT_APP_REFETCH_SECONDS) : 30;

export const genresApi = createApi({
    reducerPath: 'genresApi',
    baseQuery,
    tagTypes: ["genres"],
    keepUnusedDataFor: 300,
    refetchOnMountOrArgChange: refetchSeconds,
    endpoints: (builder) => ({
        getGenres: builder.query<any, any>({
            query: () => ({url: `genres`}),
            providesTags: ['genres']
        })
    })
});

export const {
    useLazyGetGenresQuery
} = genresApi;
